module.exports = __webpack_public_path__ + "assets/img/Deep.a0901beb.svg";